
import { useState } from 'react';
import { Canvas } from './components/Drawing/Canvas';
import { MainToolbar } from './components/Drawing/Toolbar/MainToolbar';
import { SecondaryToolbar } from './components/Drawing/Toolbar/SecondaryToolbar';
import { useKeyboard } from './hooks/useKeyboard';

function App() {
  // Initialize keyboard shortcuts
  useKeyboard();
  
  // State to control secondary toolbar visibility
  const [showSecondaryToolbar, setShowSecondaryToolbar] = useState(false);
  const [mainToolbarPosition, setMainToolbarPosition] = useState({ x: 20, y: 20 });

  return (
    <div className="w-screen h-screen bg-gray-50 overflow-hidden relative">
      {/* Main drawing canvas */}
      <Canvas className="w-full h-full" />
      
      {/* Floating toolbars */}
      <MainToolbar 
        onToolbarClick={() => setShowSecondaryToolbar(true)}
        onPositionChange={setMainToolbarPosition}
      />
      {showSecondaryToolbar && (
        <SecondaryToolbar 
          onClose={() => setShowSecondaryToolbar(false)}
          mainToolbarPosition={mainToolbarPosition}
        />
      )}
    </div>
  );
}

export default App;
